/* eslint-disable linebreak-style */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable import/extensions */

import React, { useState } from "react";
import { Fade } from "react-awesome-reveal";

const ContactForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    subject: "",
    message: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Note: Form submission is disabled due to sandbox restrictions.
    // In a real app, you would send this data to a backend API.
    console.log("Form submitted:", formData);
    alert("Form submission is disabled in this environment.");
  };

  return (
    <div className="container px-6 py-12 mx-auto bg-gray-50">
      <Fade bottom triggerOnce>
        <h2 className="mb-4 text-4xl font-bold text-center text-gray-800">
          Get In Touch
        </h2>
        <p className="mb-12 text-center text-gray-500">
          Fill out the form below and we&apos;ll get back to you as soon as
          possible.
        </p>
        <div className="max-w-2xl p-8 mx-auto bg-white rounded-lg shadow-md">
          {/* eslint-disable jsx-a11y/label-has-associated-control */}
          <form onSubmit={handleSubmit}>
            <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
              <div>
                <label
                  htmlFor="name"
                  className="block mb-2 font-semibold text-gray-700"
                >
                  Name
                </label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-teal-500"
                  placeholder="Your Name"
                  required
                />
              </div>
              <div>
                <label
                  htmlFor="email"
                  className="block mb-2 font-semibold text-gray-700"
                >
                  Email
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-teal-500"
                  placeholder="Your Email"
                  required
                />
              </div>
              <div>
                <label
                  htmlFor="phone"
                  className="block mb-2 font-semibold text-gray-700"
                >
                  Phone
                </label>
                <input
                  type="tel"
                  id="phone"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-teal-500"
                  placeholder="Your Phone"
                />
              </div>
              <div>
                <label
                  htmlFor="subject"
                  className="block mb-2 font-semibold text-gray-700"
                >
                  Subject
                </label>
                <input
                  type="text"
                  id="subject"
                  name="subject"
                  value={formData.subject}
                  onChange={handleChange}
                  className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-teal-500"
                  placeholder="Subject"
                  required
                />
              </div>
            </div>
            <div className="mt-6">
              <label
                htmlFor="message"
                className="block mb-2 font-semibold text-gray-700"
              >
                Message
              </label>
              <textarea
                id="message"
                name="message"
                value={formData.message}
                onChange={handleChange}
                className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-teal-500"
                rows="5"
                placeholder="Your Message"
                required
              />
            </div>
            <div className="mt-6 text-center">
              <button
                type="submit"
                className="px-6 py-3 text-white transition bg-teal-500 rounded-lg hover:bg-teal-600"
              >
                Send Message
              </button>
            </div>
          </form>
        </div>
      </Fade>
    </div>
  );
};

export default ContactForm;
